import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography
} from "@mui/material"
import React from "react"
import {useTranslation} from "react-i18next"

interface Props {
    onClose(): void
}

export const RedirectToTCSDialog = ({onClose}: Props) => {
    const {t} = useTranslation()

    // Detect platform
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
    const isAndroid = /Android/.test(navigator.userAgent)

    // App Store URLs
    const iosAppStoreUrl = "https://apps.apple.com/app/tcs-touring-club-schweiz/id962678119"
    const androidPlayStoreUrl = "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.iAgentur.tcs"

    // Deep link for direct app opening (nice to have)
    const tcsAppDeepLink = "tcs://"

    const handleOpenApp = () => {
        if (isIOS || isAndroid) {
            const start = Date.now()
            const storeUrl = isIOS ? iosAppStoreUrl : androidPlayStoreUrl

            window.location.href = tcsAppDeepLink

            setTimeout(() => {
                if (Date.now() - start < 2000) {
                    window.location.href = storeUrl
                }
            }, 1500)
        } else {
            window.location.href = "https://www.tcs.ch/fr/tools/app-tcs/"
        }
    }

    return (
        <Dialog open={true} onClose={onClose} className='dialog'>
            <DialogTitle>
                <Stack alignItems={'flex-start'}>
                    <Typography variant="h3" sx={{mb: 0.5}}>{t('Use_TCS_App_Title')}</Typography>
                </Stack>
            </DialogTitle>

            <DialogContent>
                <Typography variant="body1">
                    {t('Use_TCS_App_Description')}
                </Typography>
            </DialogContent>

            <DialogActions>
                <Stack direction="row" spacing={1} sx={{width: '100%', justifyContent: 'flex-end'}}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        sx={{fontSize: 14}}
                        onClick={onClose}
                    >
                        {t('Cancel')}
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        sx={{fontSize: 14}}
                        onClick={handleOpenApp}
                    >
                        {t('Open_TCS_App')}
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    )
}

